import PropTypes from 'prop-types';
import { css } from 'linaria';
import { CrossIcon } from '@pocket/web-ui';
import { breakpointSmallHandset, breakpointMediumTablet } from '@pocket/web-ui';
import EmailSignupForm from 'components/email-signup-form/email-signup-form';
import VisibilitySensor from 'components/visibility-sensor/visibility-sensor';
import BorderSVG from 'static/images/pocket-hits-chyron/border.svg';
import Green from 'static/images/pocket-hits-chyron/envelope-green.svg';
import Red from 'static/images/pocket-hits-chyron/envelope-red.svg';
const Border = BorderSVG.src || '';
const EnvelopeGreen = Green.src || '';
const EnvelopeRed = Red.src || '';
const DEFAULT_ERROR = 'Oops! Something went wrong.';
const FORM_ID = 'syndicated-article-illustrated-chyron';
const ctaContainer = "cxq1vo1";
const ctaBox = "c1e3cze7";
const closeIcon = "ctsnnyt";
const illustration = "iadbq2n";
const promoBlurbWrapper = "ps9t75v";
const promoBlurb = "puqw1gr";
const captchaDisclaimer = "c1wemiw3";

const PocketHitsIllustratedChyron = ({
  isProcessing,
  isSuccessful,
  handleEmailSubmit,
  handleEmailInputFocus,
  handleValidationError,
  signupError,
  onVisible,
  handleEmailDismiss,
  dismissChyron,
  completeChyron
}) => {
  function onValidEmailSubmit(...args) {
    completeChyron();
    handleEmailSubmit(...args);
  }

  function onDismiss() {
    handleEmailDismiss(FORM_ID);
    dismissChyron();
  }

  function handleVisible() {
    onVisible(FORM_ID);
  }

  return <VisibilitySensor onVisible={handleVisible}>
      <aside className={ctaContainer}>
        <div className={closeIcon} onClick={onDismiss}>
          <CrossIcon />
        </div>
        <div className={ctaBox}>
          <figure className={illustration} />
          {isSuccessful ? <div className={promoBlurbWrapper}>
              <h3 className={promoBlurb} data-cy="pocket-hits-chyron-success">
                All set. You’ll get your first email from us tomorrow.&nbsp;Enjoy!
              </h3>
            </div> : <div>
              <section data-cy="pocket-hits-chyron">
                <h3 className={promoBlurb}>
                  Get fascinating stories daily with <span>Pocket’s newsletter</span>.
                </h3>
                <div id="pocket-hits-illustrated-chyron">
                  <EmailSignupForm instanceId={FORM_ID} isProcessing={isProcessing} buttonLabelProcessing={'...'} onFocus={handleEmailInputFocus} onValidSubmit={onValidEmailSubmit} onValidationError={handleValidationError} errorMessage={signupError ? DEFAULT_ERROR : null} displayErrorInline buttonVariant="emphasized" hideCaptchaBadge />
                </div>
              </section>
              <div className={captchaDisclaimer}>
                This site is protected by reCAPTCHA.&nbsp;
                <span>
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                    Privacy
                  </a>
                  &nbsp;·&nbsp;
                  <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
                    Terms
                  </a>
                </span>
              </div>
            </div>}
        </div>
      </aside>
    </VisibilitySensor>;
};

PocketHitsIllustratedChyron.propTypes = {
  /**
   * Set to true to apply a loading state where the form will be disabled.
   */
  isProcessing: PropTypes.bool,

  /**
   * Set to true to display success header
   */
  isSuccessful: PropTypes.bool,

  /**
   * Called when the user has submitted a valid email and successfully passed the
   * Recaptcha. The recaptcha response key is provided so that it can be passed
   * to the backend endpoint validating this form submission.
   */
  handleEmailSubmit: PropTypes.func,

  /**
   * Called when a user focuses on the text input.
   * Intended for analytics callbacks
   */
  handleEmailInputFocus: PropTypes.func,

  /**
   * Called when the user submits a value that fails email validation.
   */
  handleValidationError: PropTypes.func,

  /**
   * Called the first time that the component becomes visible in the viewport.
   * Intended for analytics callbacks
   */
  onVisible: PropTypes.func,

  /**
   * Called when a user dismisses the Chyron
   * Intended for analytics callbacks
   */
  handleEmailDismiss: PropTypes.func,

  /**
   * Set to true to display error message on the form
   */
  signupError: PropTypes.bool
};
PocketHitsIllustratedChyron.defaultProps = {
  isProcessing: false,
  isSuccessful: false,

  handleEmailSubmit() {},

  handleEmailInputFocus() {},

  handleValidationError() {},

  onVisible() {},

  handleEmailDismiss() {},

  signupError: false
};
export { PocketHitsIllustratedChyron };

require("../../../.linaria-cache/src/components/pocket-hits-chyron/pocket-hits-illustrated-chyron.linaria.module.css");